class SwiperSlideCard extends HTMLElement {
  constructor() {
    super();
    this.showButton = this.querySelector(".button-show");
    this.closeButton = this.querySelector(".button-close");
    this.slideText = this.querySelector(".slide-text");
    this.init();
  }

  init() {
    this.bindEvents();
  }

  bindEvents() {
    if (!this.showButton || !this.closeButton || !this.slideText) return;

    // 点击 Show More 按钮
    this.showButton.addEventListener("click", (e) => {
      this.handleShowMore(e);
    });

    // 点击 Show Less 按钮
    this.closeButton.addEventListener("click", (e) => {
      this.handleShowLess(e);
    });
  }

  handleShowMore(e) {
    e.preventDefault();
    e.stopPropagation();

    // 添加展开类
    this.slideText.classList.add("expanded");

    // 切换按钮显示
    this.showButton.classList.remove("active");
    this.closeButton.classList.add("active");
  }

  handleShowLess(e) {
    e.preventDefault();
    e.stopPropagation();

    // 移除展开类
    this.slideText.classList.remove("expanded");

    // 切换按钮显示
    this.closeButton.classList.remove("active");
    this.showButton.classList.add("active");
  }
}

customElements.define("swiper-slide-card", SwiperSlideCard);
